import { FormInstance } from 'antd';
import { t } from 'i18next';
import { CustomerInformationStepData, SiteConfigurationStepData, FormValues } from '@/store/SiteSurveyForm/constants';
import { getTierAndUsageFromSelection } from '@/comp/Forms/SiteSurveyForm/CustomerInformationStep/CustomerInformationContent.utils';

export interface UnifiedSiteSurveyFormProps {
  isLoading: boolean;
  isThankYouScreenShown: boolean;
  initialAccountId?: string;
  onHomeSubmit: (values: { accountId: string }) => void;
  onCustomerInformationStepNext: (values: CustomerInformationStepData) => void;
  onSiteConfigurationStepNext: (
    values: { customerInformationData?: CustomerInformationStepData } & SiteConfigurationStepData,
  ) => void;
  onRoomConfigurationStepFinish: () => void;
  onPrevious: () => void;
  onClose?: () => void;
  form: FormInstance;
  formData?: {
    accountId?: string;
    salesforceId?: string | null;
    formId?: string | null;
  };
}

export const getButtonText = (currentStep: number): string => {
  switch (currentStep) {
    case 0:
    case 1:
    case 2:
      return t('Continue');
    case 3:
      return t('Create Station');
    default:
      return t('Continue');
  }
};

export const handleFinish = async (
  values: FormValues,
  fetchAccountData: (accountId: string) => Promise<void>,
  customerInformationData: CustomerInformationStepData,
  updateCustomerInformationData: (data: CustomerInformationStepData) => void,
  updateSiteConfigurationStepData: (data: SiteConfigurationStepData) => void,
  siteSurveyStore: { currentStep: number },
  onHomeSubmit: (values: { accountId: string }) => void,
  onCustomerInformationStepNext: (values: CustomerInformationStepData) => void,
  onSiteConfigurationStepNext: (
    values: { customerInformationData?: CustomerInformationStepData } & SiteConfigurationStepData,
  ) => void,
  onRoomConfigurationStepFinish: () => void,
): Promise<void> => {
  switch (siteSurveyStore.currentStep) {
    case 0:
      if (!values.accountId) {
        throw new Error('Account ID is required');
      }
      await fetchAccountData(values.accountId);
      onHomeSubmit({ accountId: values.accountId });
      break;

    case 1: {
      const formValues = values as Partial<CustomerInformationStepData>;

      const selectedTier = formValues.tier || '';
      const { tier, stationUsageType } = getTierAndUsageFromSelection(selectedTier);

      const completeValues: CustomerInformationStepData = {
        ...formValues,
        tier,
        stationUsageType,
        customer: customerInformationData.customer,
        siteAddress: customerInformationData.siteAddress,
        contactPerson: customerInformationData.contactPerson,
        accountManager: customerInformationData.accountManager,
      } as CustomerInformationStepData;

      updateCustomerInformationData(completeValues);
      onCustomerInformationStepNext(completeValues);
      break;
    }

    case 2: {
      const siteConfigurationStepData = values as unknown as SiteConfigurationStepData;
      updateSiteConfigurationStepData(siteConfigurationStepData);

      onSiteConfigurationStepNext({
        ...siteConfigurationStepData,
        customerInformationData: customerInformationData,
      });
      break;
    }

    case 3:
      onRoomConfigurationStepFinish();
      break;
  }
};
